<div class="p-component">
  <div class="wrapper">
      <div class="body">
          <router-outlet></router-outlet>
      </div>
  </div>
</div>
